import styled from "styled-components";

export const TabsContentStyled = styled.div`
  box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.05);
  display: none;
  @media screen and (max-width: 709px ) {
    display: block;
  }
`;

export const TabItemTitleStyled = styled.div<{ isActive: boolean }>`
  border-bottom: 2px solid ${p => (p.isActive ? '#95B040' : '#C8C8C8')};
  height: 49px;
  line-height: 49px;
  display: inline-block;
  padding: 0 12px;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
  font-family: 'Nunito Sans';
  font-weight: 800;
  width: 50%;
  cursor: pointer;
`;

export const TabItemContentStyled = styled.div<{ isActive: boolean }>`
  display: ${p => (p.isActive ? 'block' : 'none')};
  padding: 0 12px;
  > div {
    margin-bottom: 12px;
  }
  > p {
    text-align: center;
    font-family: 'Nunito Sans';
    font-size: 14px;
    padding: 12px 0;
  }
`;
